import { render } from "./MainVideo.vue?vue&type=template&id=eb6403de&scoped=true"
import script from "./MainVideo.vue?vue&type=script&lang=js"
export * from "./MainVideo.vue?vue&type=script&lang=js"

import "./MainVideo.vue?vue&type=style&index=0&id=eb6403de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb6403de"

export default script